/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdWatermarkProps } from './type';

export const watermarkDefaultProps: TdWatermarkProps = {
  alpha: 1,
  isRepeat: true,
  layout: 'rectangular',
  lineSpace: 16,
  movable: false,
  moveInterval: 3000,
  removable: false,
  rotate: -22,
};
